export const countryId = 147; //Nepal default country
// export const countryId = 96; // Indonesia default country

export const nameFormat = {
  firstName: "Sita",
  middleName: "Kumari",
  lastName: "Shrestha",
};
